import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ContactExpertIcon extends BaseIcon {
  getChildren = () => {
    return [
      <g id="Group_14321" data-name="Group 14321" transform="translate(-1546 -102)">
        <g id="Group_14323" data-name="Group 14323" transform="translate(1546 102)">
          <path id="Path_18920" data-name="Path 18920" d="M16,1.714A1.714,1.714,0,0,0,14.286,0H1.714A1.714,1.714,0,0,0,0,1.714v9.714a1.714,1.714,0,0,0,1.714,1.714H3.143a.286.286,0,0,1,.286.286v2a.571.571,0,0,0,.32.514A.674.674,0,0,0,4,16a.583.583,0,0,0,.354-.126L7.691,13.2a.343.343,0,0,1,.183-.057h6.411A1.714,1.714,0,0,0,16,11.429ZM8,11.429a1.143,1.143,0,1,1,1.143-1.143A1.143,1.143,0,0,1,8,11.429ZM8,8A.857.857,0,1,1,8,6.286,1.429,1.429,0,1,0,6.571,4.857a.857.857,0,0,1-1.714,0A3.143,3.143,0,1,1,8,8Z" fill="#9babc1"/>
        </g>
      </g>
    ]
  }
  getViewBox = () => '0 0 15.088 16'
}
